import * as React from "react";
const SvgPolishLines = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m117.5 112.5-106-101", style: {
  fill: "none",
  stroke: "#080",
  strokeWidth: 3,
  strokeOpacity: 1
} }));
export default SvgPolishLines;
